import type { SearchParams } from '@/types';

export const quoteSqlString = (value: string): string => `'${value.replace(/'/g, "''")}'`;

export const prepareSearchClause = (searchParams: Pick<SearchParams, 'search' | 'county' | 'mode'>): string => {
    const search = (searchParams.county === 'Alameda' ? searchParams.search.trimStart() : searchParams.search.trim()).toUpperCase();
    let clause: string;
    switch (searchParams.mode) {
        case 'address':
            clause = `S_ADDR_D LIKE ${quoteSqlString(`${search.replace(/ /g, '%')}%`)}`;
            break;
        case 'owner': {
            const segments = search.split(' ', 2).filter(Boolean);
            clause = segments.length > 1
                ? `(NAMES LIKE ${quoteSqlString(`${segments[0]}%${segments[1]}%`)} OR NAMES LIKE ${quoteSqlString(`${segments[1]}%${segments[0]}%`)})`
                : `NAMES LIKE ${quoteSqlString(`${segments[0] ?? ''}%`)}`;
            break;
        }
        case 'apn':
            clause = `APN_D LIKE ${quoteSqlString(searchParams.county === 'Ventura' ? search : `${search.replace(/[^0-9-]/g, '%')}%`)}`;
            break;
    }
    return `${clause} AND county_name = ${quoteSqlString(searchParams.county)}`;
};
